export const formatPrice = ({
  price,
  fractionDigits = 2,
}: {
  price: number;
  fractionDigits?: number;
}) => {
  return Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(price);
};
